<div class="generate-input-files-wrapper">
  <div class="summary-wrapper">
    <details open>
      <summary>Upload File to Staging</summary>
      <div class="description">
        <p>Upload a file to the staging container for Run ID: <strong>{{ runId }}</strong></p>
      </div>
    </details>
  </div>
  
  <div class="forms-wrapper">
    <div class="required-text">* Required</div>
    <form>
      <div class="row">
        <div class="col-12">
          <div class="forms-group"
             [ngClass]="{
               'has-error': fileControl.invalid && fileControl.touched
             }">
            <div class="form-label upload-label">
              Select File
              <span>*</span>
            </div>
            <div class="info-msg">
              Upload a file to be used during module execution
            </div>            <div class="upload-container">
              @for (uploadState of getUploadStatesArray(); track uploadState.fileName) {
                <div class="upload-info">
                  <div class="file-uploaded-wrapper">
                    <div class="file-uploaded-icon">
                      @if (uploadState.fileName.endsWith('.csv')) {
                        <kendo-svgicon [icon]="fileCsvIcon"></kendo-svgicon>
                      }
                      @else if (uploadState.fileName.endsWith('.doc') || uploadState.fileName.endsWith('.docx')) {
                        <kendo-svgicon [icon]="fileWordIcon"></kendo-svgicon>
                      }
                      @else if (uploadState.fileName.endsWith('.pdf')) {
                        <kendo-svgicon [icon]="filePdfIcon"></kendo-svgicon>
                      }
                      @else if (uploadState.fileName.endsWith('.pptx')) {
                        <kendo-svgicon [icon]="filePptIcon"></kendo-svgicon>
                      }
                      @else if (uploadState.fileName.endsWith('.msg')) {
                        <kendo-svgicon [icon]="fileReportIcon"></kendo-svgicon>
                      }
                      @else if (uploadState.fileName.endsWith('.txt')) {
                        <kendo-svgicon [icon]="fileTxtIcon"></kendo-svgicon>
                      }
                      @else if (uploadState.fileName.endsWith('.xls') || uploadState.fileName.endsWith('.xlsx')) {
                        <kendo-svgicon [icon]="fileExcelIcon"></kendo-svgicon>
                      }
                      @else if (uploadState.fileName.endsWith('.zip')) {
                        <kendo-svgicon [icon]="fileZipIcon"></kendo-svgicon>
                      }
                      @else if (uploadState.fileName.endsWith('.sql')) {
                        <kendo-svgicon [icon]="dataSqlIcon"></kendo-svgicon>
                      }
                      @else {
                        <kendo-svgicon [icon]="fileIcon"></kendo-svgicon>
                      }
                    </div>
                    <div class="file-uploaded-text">
                      <div class="file-msg">
                        File: {{ uploadState.fileName }}
                      </div>
                      <div class="upload-msg"
                       [ngClass]="{
                              'upload-success': uploadState.uploadSuccess,
                              'upload-error': uploadState.uploadError,
                          }">
                        {{uploadState.uploadMessage}}
                      </div>
                    </div>
                    <div class="file-uploaded-close">
                      @if (uploadState.uploading || uploadState.uploadProgress === 100) {
                        <div class="progress-label">
                          {{ uploadState.uploadProgress | number:'1.0-0' }}%
                        </div>
                      }
                      <button type="button" (click)="removeFile(uploadState.fileName)" [svgIcon]="xIcon" kendoButton></button>
                    </div>
                  </div>
                  <div class="progress-wrapper">
                    <kendo-progressbar [value]="uploadState.uploadProgress" [animation]="true">
                    </kendo-progressbar>
                  </div>
                </div>
              }

              <div class="dropzone-wrapper">
                <kendo-uploaddropzone zoneId="stagingZone">
                  <p class="drag-drop-text">
                    Drag and drop files or
                    <a (click)="browseUpload($event)">browse</a>
                    to upload more files.
                  </p>
                </kendo-uploaddropzone>
                <kendo-upload
                  #upload
                  zoneId="stagingZone"
                  (select)="onSelect($event)"
                  (upload)="onUpload($event)"
                  (remove)="onRemove($event)"
                  [restrictions]="uploadRestrictions"
                  [multiple]="true"
                  [autoUpload]="true"
                  [showFileList]="false"
                  [saveUrl]="'about:blank'">
                </kendo-upload>
              </div>
            </div>@if (uploadStates.size === 0 && activeUploads === 0 && fileControl.invalid) {
              <div class="info-msg error-msg">
                @if (fileControl.errors?.['required'] && fileControl.touched) {
                  Required field needs a selection
                }
              </div>
            }
            @if (hasSuccessfulUploads()) {
              <div class="info-msg success-msg">
                <strong>All files received!</strong> If you would like to proceed with these files, please return to the agent.
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
